import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService, BaseComponent, CodeAndArgs, Message} from 'iui-iconectiv-lib';

import { Roles } from '../shared';

import { SummaryService } from './summary.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styles: [`
  `]
})
export class SummaryComponent extends BaseComponent {

  myAccount: any;

  constructor(
    authService: AuthenticationService,
    private router: Router,
    private summaryService: SummaryService) {

    super();

    if (authService.hasRole(Roles.ServiceDesk)) {
      this.log.debug('authService.hasRole(Roles.ServiceDesk): ' + authService.hasRole(Roles.ServiceDesk));
      router.navigate(['/servicedesk']);
    }
    else if (authService.hasRole(Roles.CustomerAdmin)) {
      this.verifyAccountStatus();
    }
    else if (authService.hasRole(Roles.CustomerUser)) {
      router.navigate(['/search']);
    }
    else {
      this.displayTranslatedErrorMessage(new CodeAndArgs('pqs.unknownrole'));
    }
  }


  /**
   * Verify whether the account is active,
   * if not, ensure to obtain:
   * 1. the service agreement acceptance
   * 2. and the completion of the account.
   */
  verifyAccountStatus() {
    this.summaryService.getMyAccount().subscribe(
      resp => {
        this.log.debug(`verifyAccountStatus(): data=${JSON.stringify(resp)}`);
        if (resp['status'] === 'fail') {
          // prepare error message
          const message: any = resp['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`verifyAccountStatus(): errorMessage=${errorMessage}`);
          this.displayError();
        } else {
          this.myAccount = resp['Account'] || null;
          if (this.myAccount != null) {
            this.processAccount();
          } else {
            this.log.error(`verifyAccountStatus(): account is empty`);
            this.displayError();
          }
        }
      },
      error => {
        this.log.error(`verifyAccountStatus(): got HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }


  /**
   * If account is active, then navigate to /search page.
   *
   * If account is approved and the service agreement is not accepted yet
   *  navigate to /service-agreement page
   * else if account is approved and service agreement is accepted
   *  navigate to /account-completion page.
   */
  processAccount() {
    const accountStatus = this.myAccount['status'];
    const serviceAgreementAccepted = this.myAccount['serviceAgreementAccepted'];
    this.log.debug(`accountStatus=${accountStatus}, serviceAgreementAccepted=${serviceAgreementAccepted}`);

    if (accountStatus === 'active') {
      this.router.navigate(['/search']);
    } else if (accountStatus === 'approved') {
      // save account data to session storage for later
      this.summaryService.setFinderAccount(this.myAccount);
      if (serviceAgreementAccepted === false) {
        this.router.navigate(['/service-agreement']);
      } else {
        this.router.navigate(['/account-completion']);
      }
    }
  }


  /**
   * call base class's displayErrorMessage() for error.
   */
  displayError() {
    this.displayErrorMessage(
      new Message('Error', 'The system was unsuccessful in processing your request. Please try again, or contact Customer Support for assistance.')
    );
  }

}
